<template>
  <div v-if="oneUnitPerPitch" v-bind="$attrs" class="one-unit-per-pitch">
    <div class="unit-per-pitch">
      <translate>One unit per pitch</translate>
      <pu-popover>
        <template #content>
          <div>
            <translate :tt="{ categoriesText }">
              Only one {categoriesText} unit allowed per pitch (not including
              pup tent, awning, gazebo).
            </translate>
            <translate
              tag="p"
              v-if="additionalUnitsMsg"
              style="margin-top: 1em"
            >
              Additional units require additional pitches - quick book via Make
              another booking like this after making your booking.
            </translate>
          </div>
        </template>
      </pu-popover>
    </div>
  </div>
  <div v-else v-bind="$attrs" class="unit-per-pitch">
    <translate>Multiple units are allowed per pitch</translate>
    <pu-popover>
      <template #content>
        <div>
          <translate :tt="{ categoriesText }">
            Multiple {categoriesText} are allowed per pitch.
          </translate>
          <translate tag="p" style="margin-top: 1em">
            Please ensure your units will fit within the pitch size listed, and
            that you do not exceed the max. persons for this pitch.
          </translate>
        </div>
      </template>
    </pu-popover>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { AllowedSubcategory } from '../../apps/campsite-details/types'

interface Props {
  oneUnitPerPitch: boolean
  additionalUnitsMsg?: boolean
  allowedSubcategories: AllowedSubcategory[]
}

const props = withDefaults(defineProps<Props>(), {
  additionalUnitsMsg: true,
})

const { t } = useI18n()

const categoriesText = computed(() =>
  (props.allowedSubcategories || []).join(` ${t('or')} `),
)
</script>

<style scoped>
.unit-per-pitch {
  position: relative;
  font-size: var(--body);
}

.unit-per-pitch :deep(aside) {
  margin: 0 0 0 0.1em;
}
</style>
